import {
  AssociationId,
  IntegrationNamesEnum,
  IntegrationWarnings,
  ProcessTypesEnum,
  ProfilePk,
  UnixMsString,
} from "../../types"
import { httpGet, httpPost } from "../remoteDataProvider"

async function triggerSync(
  integrationName: IntegrationNamesEnum,
  association: AssociationId,
  token: string,
  shouldPostBatchProfiles?: boolean,
) {
  const { data } = await httpPost(
    "people_flow_core",
    `/integrations/trigger/${integrationName}/${association}`,
    { shouldPostBatchProfiles },
    token,
  )
  const { importId } = data
  return importId
}

async function bundleErrorLogs(
  association: AssociationId,
  integrationName: IntegrationNamesEnum,
  timerange: { fromUnixMsString: UnixMsString; toUnixMsString: UnixMsString },
  token: string,
) {
  const { POST_ADAGIN_EMPLOYEES, POST_AGRIGISTICS_EMPLOYEES } = ProcessTypesEnum
  const processType =
    integrationName === IntegrationNamesEnum.ADAGIN ? POST_ADAGIN_EMPLOYEES : POST_AGRIGISTICS_EMPLOYEES
  const { fromUnixMsString, toUnixMsString } = timerange
  const { data } = await httpPost(
    "people_flow_core",
    `/integrations/error-logs/${association}/${processType}/${fromUnixMsString}/${toUnixMsString}`,
    {},
    token,
  )
  return data
}

async function fetchSourceFiles(
  integrationName: IntegrationNamesEnum,
  association: AssociationId,
  token: string,
): Promise<{ Key: string }[]> {
  const { data } = await httpGet(
    "people_flow_core",
    `/integrations/backup-file-metadata/${integrationName}/${association}`,
    token,
  )
  return data
}

async function fetchIntegrationWarnings(association: AssociationId, token: string): Promise<IntegrationWarnings[]> {
  const { data } = await httpGet("people_flow_core", `/integrations/warning-resolution/${association}`, token)
  if (!data) {
    return []
  }
  return data.items as IntegrationWarnings[]
}

async function markIntegrationWarningResolved(
  profilePks: ProfilePk[],
  association: AssociationId,
  token: string,
): Promise<IntegrationWarnings[]> {
  const { data } = await httpPost(
    "people_flow_core",
    `/integrations/warning-resolution/${association}`,
    { profilePks },
    token,
  )
  return data.items as IntegrationWarnings[]
}

async function publishToModernApi(association: AssociationId, token: string): Promise<void> {
  await httpPost("people_flow_core", `/integrations/publish-to-modern-api/${association}`, {}, token)
}

export {
  bundleErrorLogs,
  fetchSourceFiles,
  triggerSync,
  fetchIntegrationWarnings,
  markIntegrationWarningResolved,
  publishToModernApi,
}
